import { render, staticRenderFns } from "./propmotion-detail.vue?vue&type=template&id=71267339&"
import script from "./propmotion-detail.vue?vue&type=script&lang=js&"
export * from "./propmotion-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports